module.exports = __webpack_public_path__ + "static/interior3x-c0e1ac9c7589a8b77db189fe6e6a2048.png";